module.exports = __webpack_public_path__ + "static/img/mechanism-of-action.5a7f3a70.png";